import { ImgHTMLAttributes } from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { CompanyImg, CompanyImgWrap, UploaderContainer } from './styles'

interface CompanyImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  mini?: boolean
  large?: boolean
  uploadingProgress?: number
}

function CompanyImage(props: CompanyImageProps) {
  return (
    <CompanyImgWrap $mini={props.mini} $large={props.large}>
      {props.uploadingProgress && (
        <UploaderContainer>
          <CircularProgressbar value={props.uploadingProgress} />
        </UploaderContainer>
      )}
      <CompanyImg
        src={props.src}
        alt={props.alt || 'Company Image'}
        loadingInProgress={Boolean(props.uploadingProgress)}
      />
    </CompanyImgWrap>
  )
}

export default CompanyImage
